import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import Input from '../common/Input';

// Substitui window.prompt no fluxo "marcar enviado".
// onConfirm({ trackingCode, carrier }) chamado com valores.
const ShipmentModal = ({ isOpen, onClose, onConfirm, defaultTrackingCode = '', loading = false }) => {
  const [trackingCode, setTrackingCode] = useState(defaultTrackingCode);
  const [carrier, setCarrier] = useState('');

  React.useEffect(() => {
    if (isOpen) {
      setTrackingCode(defaultTrackingCode);
      setCarrier('');
    }
  }, [isOpen, defaultTrackingCode]);

  const handleConfirm = () => {
    onConfirm?.({
      trackingCode: trackingCode.trim() || null,
      carrier: carrier.trim() || null,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Marcar pedido como enviado"
      size="sm"
      closeOnOverlayClick={!loading}
      footer={
        <>
          <Button variant="subtle" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirm} loading={loading}>
            Confirmar envio
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <Input
          label="Código de rastreio (opcional)"
          value={trackingCode}
          onChange={(e) => setTrackingCode(e.target.value)}
          placeholder="BR1234567890"
          autoFocus
        />
        <Input
          label="Transportadora (opcional)"
          value={carrier}
          onChange={(e) => setCarrier(e.target.value)}
          placeholder="Correios, Jadlog, etc."
        />
      </div>
    </Modal>
  );
};

export default ShipmentModal;
